import { writable } from 'svelte/store';

export type SessionState = 'unknown' | 'in' | 'out';

/** 'unknown' until the first probe resolves; 'out' also set centrally on any 401. */
export const session = writable<SessionState>('unknown');

export function sessionIn(): void {
  session.set('in');
}
export function sessionExpired(): void {
  session.set('out');
}
